export * from "./admins";
export * from "./members";
export * from "./deposits";
export * from "./points";
export * from "./levels";

import codes from "./codes";
import * as ebookCompanies from "./ebook-companies";
import * as terms from "./terms";
import * as viewers from "./viewers";

export const user = {
    codes,
    ...ebookCompanies,
    ...terms,
    ...viewers,
};
